import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getAffiliatePartner, updateAffiliatePartner } from '../actions/affiliatepartnerActions'
import Country from '../components/Country'
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'
import { AFFILIATE_PARTNER_GET_RESET, AFFILIATE_PARTNER_UPDATE_RESET } from '../constants/affiliatePartnerConstants'
import { affiliatePartnerJson } from '../models/affiliatePartnerModel'

export default function AffiliatePartnerEditScreen(props) {
    const { id } = useParams();
    const dispatch = useDispatch();

    const [parameters, setParameters] = useState(affiliatePartnerJson);

    const [executed, setExecuted] = useState(0);
    const [executedtime, setexecutedtime] = useState(0);

    const affiliatePartnerDetails = useSelector(state => state.affiliatePartnerDetails)
    const { loading: loadingDetail, error: errorDetail, apartner } = affiliatePartnerDetails

    const affiliatePartnerUpdate = useSelector(state => state.affiliatePartnerUpdate)
    const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = affiliatePartnerUpdate

    const handleValue = (e) => {
        setParameters({ ...parameters, [e.target.name]: e.target.value });
    }

    const UpdateRecord = (e) => {
        dispatch(updateAffiliatePartner(id, parameters))
        //console.log(parameters)
        //dispatch(getAffiliatePartner(id))
        setExecuted(0)
        setexecutedtime(1)
    }

    useEffect(() => {
        if (successUpdate) {
            setTimeout(() => {
                dispatch({
                    type: AFFILIATE_PARTNER_UPDATE_RESET
                })
            }, 10000);
        }

        if(executed == 0){
            dispatch({
                type: AFFILIATE_PARTNER_GET_RESET
            })
            setExecuted(1)
        }

        if(apartner == undefined || apartner.length == 0){
            setexecutedtime(executedtime + 1)
            if(executedtime < 5 && executedtime > 0){
                dispatch(getAffiliatePartner(id))
            }else if(executedtime < 8){
                //console.log(apartner)
            }
        }else{
            setParameters(apartner[0])
        }
        // if (id != undefined) {
        //     if (college == undefined || college.length == 0) {
        //         dispatch(detailColleges(id))
        //     }
        //     else {
        //         setClg(college[0])
        //     }
        // }
    }, [dispatch, id, apartner, successUpdate])

    return (
        <>
            <Header pageName="Edit Affiliate Partner" />
            <LeftComponent />
            <div className="content-body">
                <div className="container-fluid">
                    <div className="heading-title">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="home-title float-left">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-body">
                        <div className="invoice-details">
                            <div className="container">
                                <div id="InvoiceAccordion" className="accordion-invoice">
                                    <div className="card mb-0">
                                        <div className="card-header collapsed" data-toggle="collapse" href="#collapseOne">
                                            <a className="card-title">
                                                Affiliate Partner Details
                                            </a>
                                        </div>

                                        <div className="card-body collapse show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Affiliate Partner Name* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="affiliate partner name"
                                                                name="Affiliate_Partner"
                                                                value={parameters.Affiliate_Partner}
                                                                onChange={e => handleValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Affiliate Partner Address* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            {/* <div className="input-group-prepend">
                                                                <span className="input-group-text">$</span>
                                                            </div> */}
                                                            <textarea className="form-control form-control-sm" placeholder="address..."
                                                                name="AffiliatePartner_Address"
                                                                value={parameters.AffiliatePartner_Address}
                                                                onChange={e => handleValue(e)}></textarea>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Country* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="Country_Id"
                                                                value={parameters.Country_Id}
                                                                onChange={e => handleValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <Country />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-header collapsed" >
                                            <a className="card-title">
                                                Other Details
                                            </a>
                                        </div>
                                        <div className="card-body collapse show" >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" name="Contact_Person" value={parameters.Contact_Person} onChange={e => handleValue(e)} placeholder="contact person" />

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Email*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Email" value={parameters.Contact_Email} onChange={e => handleValue(e)} placeholder="contact person email" />

                                                        </div>
                                                    </div>

                                                   
                                                </div>

                                                <div className="col-md-6">
                                                <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Number*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Number" value={parameters.Contact_Number} onChange={e => handleValue(e)} placeholder="contact person number" />

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>


                                        <div className="card-header collapsed"   >
                                            <a className="card-title">
                                                Commission Details
                                            </a>
                                        </div>
                                        <div id="collapseThree" className="card-body collapse  show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Percentage*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage" name="Commision_Percentage" value={parameters.Commision_Percentage} onChange={e => handleValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Bonus*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="bonus" name="Bonus" value={parameters.Bonus} onChange={e => handleValue(e)} />

                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commision Including GST</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Commision_Including_GST" value={parameters.Commision_Including_GST} onChange={(e) => handleValue(e)}>
                                                                <option value="">--Select--</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    <hr />
                                                    <>
                                                        {
                                                            loadingUpdate ? (
                                                                <div className="Create-btn">
                                                                    Loading...
                                                                </div>
                                                            ) : (
                                                                <div className="Create-btn">
                                                                    <a className="btn create-contact"
                                                                        onClick={e => UpdateRecord(e)}>Update</a>
                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                    <span className='text-success'>{successUpdate}</span>
                                                    <span className='text-danger'>{errorUpdate}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

